export const isWindowExists = () => {
    return typeof window != 'undefined';
};

export const windowOpen = link => {
    if (!link.match(/^https?:\/\//i)) link = `http://${link}`;

    window.open(link, '_blank', 'noreferrer')?.focus();
};
